<template>
  <svg v-if="iconSvg" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="currentColor">
    <path :d="iconSvg" />
  </svg>
  <svg v-else-if="name === 'envelope'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
  </svg>
</template>

<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true
  }
})

// Map icon names to simple-icons keys
const iconMap = {
  facebook: 'Facebook',
  x: 'X',
  linkedin: 'Linkedin',  // Note: lowercase 'in' for simple-icons
  tiktok: 'Tiktok',
  wechat: 'Wechat',
  sinaweibo: 'Sinaweibo',
  xiaohongshu: 'Xiaohongshu',
  bilibili: 'Bilibili',
  kuaishou: 'Kuaishou'
}

const iconSvg = ref('')

// Load icon on mount
onMounted(async () => {
  const iconKey = iconMap[props.name]
  if (iconKey) {
    const simpleIcons = await import('simple-icons')
    const siKey = 'si' + iconKey
    if (simpleIcons[siKey]) {
      iconSvg.value = simpleIcons[siKey].path
    }
  }
})

// For SSR, load icons immediately
if (import.meta.server) {
  await loadIcon()
}

async function loadIcon() {
  const iconKey = iconMap[props.name]
  if (iconKey) {
    const simpleIcons = await import('simple-icons')
    const siKey = 'si' + iconKey
    if (simpleIcons[siKey]) {
      iconSvg.value = simpleIcons[siKey].path
    }
  }
}
</script>
